// Simple in-memory cache with TTL
// Lives as long as the browser tab is open — survives React remounts/navigations
const store = {};

const cache = {
  set(key, value, ttlMs = 5 * 60 * 1000) {
    store[key] = { value, expiresAt: Date.now() + ttlMs };
  },
  get(key) {
    const entry = store[key];
    if (!entry) return null;
    if (Date.now() > entry.expiresAt) { delete store[key]; return null; }
    return entry.value;
  },
  clear(key) {
    if (key) delete store[key]; else Object.keys(store).forEach(k => delete store[k]);
  },
};

export default cache;
